import ApiService from '../common/api.service';

import {
  FETCH_PORTICO_DETAIL, FETCH_PORTICOS_SUBCONDOMINIOS, SET_PORTICO_SUBCONDOMINIOS,
} from './actions.type';

import {
  SET_ERROR,
} from './mutations.type';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
};

const getters = {
};

const actions = {
  [FETCH_PORTICOS_SUBCONDOMINIOS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query('accesos/subcondominios')
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [FETCH_PORTICO_DETAIL](context, porticoId) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.query(`accesos/obtener_detalle_portico/${porticoId}`)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
  [SET_PORTICO_SUBCONDOMINIOS](context, payload) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      ApiService.post(`accesos/asignar_subcondominios_portico/${payload.portico_id}`,
        { subcondominios: payload.subcondominios })
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
        });
    });
  },
};

const mutations = {
  [SET_ERROR](state, data) {
    state.alert = true;
    state.alertMessage = data;
    state.alertType = 'error';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
